import { LoggedInLayout } from "layouts";
import {
	ApplicationRegistry,
	BackofficeHome,
	BackofficeLogin,
	BackofficeUserNotFound
} from "pages/Backoffice";
import BackofficeApplicationPage from "pages/Backoffice/ApplicationPage";
import { BackofficeApplicationPageTabs } from "pages/Backoffice/ApplicationPage/types";
import { useCurrentUser } from "providers/CurrentUserProvider";
import { Navigate, Route, Routes } from "react-router-dom";

export default function BackofficeRoutes() {
	const user = useCurrentUser();
	const defaultRedirectUrl = user?.defaultRedirectUrl() ?? "/";
	return (
		<Routes>
			<>
				{user?.hasBackofficePermission() && (
					<Route path="/" element={<LoggedInLayout />}>
						<Route path="/consulta" element={<ApplicationRegistry />} />
						<Route path="/" element={<BackofficeHome />} />
						<Route
							path="/solicitacao/:applicationId"
							element={
								<Navigate to={`./${BackofficeApplicationPageTabs.DETAILS}`} />
							}
						/>
						<Route
							path="/solicitacao/:applicationId/:selectedTab"
							element={<BackofficeApplicationPage />}
						/>
					</Route>
				)}
				{!user && (
					<>
						<Route path="/sem-cadastro" element={<BackofficeUserNotFound />} />
						<Route path="/" element={<BackofficeLogin />} />
					</>
				)}
				<Route path="*" element={<Navigate to={defaultRedirectUrl} />} />
			</>
		</Routes>
	);
}
